// Dependency
import React from 'react';

// Styles
import * as styles from './modal-flyin.module.scss';

// Assets
import iconClose from './assets/icon-close.svg';
import BundleModal from '../../product/bundle/bundle-modal';

// Template
const ContentFlyIn = ({ direction, isOpen, flyinToggle, content }) => {
  return (
    <div className={`
      ${styles.modalFlyIn}
      ${isOpen ? styles.isOpen : ''}
    `}>
      <div className={`
        ${styles.modalFlyIn__content}
        ${direction === 'left' ? styles.fromLeft : ''}
        ${direction === 'right' ? styles.fromRight : ''}
        cd-dark-mode-black

      `}>
        <div>
          <button className={`${styles.modalFlyIn__close}`} onClick={flyinToggle}>
            <img src={iconClose} alt={''} />
          </button>
        </div>
        <div className={`${styles.modalFlyIn__content__inner}`}>
          {typeof content === "object" ? (
            <BundleModal productData={content} />
          ) : (
            <div dangerouslySetInnerHTML={{ __html: content }}></div>
          )}
        </div>
      </div>
      <button className={`
        ${styles.modalFlyIn__overlay}
        ${direction === 'left' ? styles.fromLeft : ''}
        ${direction === 'right' ? styles.fromRight : ''}
      `} onClick={flyinToggle}>
        <span className={`${styles.modalFlyIn__close}`}>Close</span>
      </button>
    </div>
  );
};

export default ContentFlyIn;